define('app/sdc/pagination/arguments/sdc-pagination-arguments',["factory!sdc-bind"], function (bindFactory) {
	"use strict";
	return bindFactory();
});
